import React from 'react';

import { Box } from '../neta';
import { Email, Facebook, Twitter, LinkedIn, Pinterest } from '../SocialIcons';
import useSticky from '../../lib/useSticky';

export default function ShareSidebar({ post, contentPath = 'articles' }) {
  const socialIconsRef = React.useRef();
  useSticky(socialIconsRef);
  const {
    twitterShareText,
    facebookShareLink,
    emailShareSubject,
    emailShareBody,
    slug
  } = post;
  const postUrl = `https://www.askzeta.com/magazine/${contentPath}/${slug}`;
  return (
    <Box display={['none', 'block']} ml={8} pl={7} width="150px">
      <Box ref={socialIconsRef} top="50px">
        <Box mb={3}>
          <Twitter shareText={twitterShareText || postUrl} />
        </Box>
        <Box mb={3}>
          <Facebook shareUrl={facebookShareLink || postUrl} />
        </Box>
        <Box mb={3}>
          <Email
            contentItem={post}
            postUrl={postUrl}
            subject={emailShareSubject}
            body={emailShareBody}
          />
        </Box>
        <Box mb={3}>
          <LinkedIn shareText="The Money Date Magazine by Zeta" shareUrl={postUrl} />
        </Box>
        <Box>
          <Pinterest
            shareUrl={postUrl}
            imageUrl={
              post.heroImage && post.heroImage.sizes && post.heroImage.sizes.src
                ? `https:${post.heroImage.sizes.src}`
                : null
            }
          />
        </Box>
      </Box>
    </Box>
  );
}
